import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button';
import NewPasswordInput from 'components/forms/NewPasswordInput';
import Heading from 'components/Heading';
import * as iconLibrary from 'components/Icons';
import Logo from 'components/Logo';
import Paragraph from 'components/Paragraph';
import { apiInstance } from 'services';
import logger from 'services/logger/logger';

import { useTheme } from '../../context/theme-context';

import styles from './ResetPasswordScreen.module.scss';

const APIService = apiInstance();
const {
  namespaces: { onboarding }
} = APIService;
let token1 = '';
let token2 = '';

const ResetPasswordScreen = () => {
  const [newPassword, setNewPassword] = useState(false);
  const { errors, register, formState, handleSubmit } = useForm({
    mode: 'onChange'
  });

  const { getCurrentTheme } = useTheme();
  const { homepage_logo } = getCurrentTheme();

  const history = useHistory();
  const { dirtyFields, isValid } = formState;
  const tokenPrefix = 'cureoscity_password_reset_';

  const onSubmit = ({ newPassword }) => {
    onboarding
      .resetPassword(token1, token2, newPassword)
      .then(() => {
        localStorage.removeItem(`${tokenPrefix}token1`);
        localStorage.removeItem(`${tokenPrefix}token2`);
        setNewPassword(true);
      })
      .catch((error) => logger.debug(error));
  };

  useEffect(() => {
    token1 = localStorage.getItem(`${tokenPrefix}token1`);
    token2 = localStorage.getItem(`${tokenPrefix}token2`);

    if (
      !onboarding.isResetTokenValid(token1) ||
      !onboarding.isResetTokenValid(token2)
    ) {
      history.push('/forgot');
    }
  }, []);

  const IconSuccess = iconLibrary.IconCircleTick;

  const renderScreen = () => {
    if (newPassword) {
      return (
        <>
          <IconSuccess />
          <div className={styles.text}>
            <Heading appearance="h4">Your password has been reset</Heading>
            <Paragraph centered>
              Your new password has successfully been reset.&nbsp; Please click
              continue to proceed to login
            </Paragraph>
          </div>
          <Button
            type="submit"
            text="Continue"
            size="full-width"
            width="100%"
            onClick={() => {
              history.push('/login');
            }}
          />
        </>
      );
    }

    return (
      <div className={styles.form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <NewPasswordInput
            {...{ errors, register, dirtyFields }}
            label="New password"
          />
          <Button
            type="submit"
            text="Reset password"
            size="full-width"
            disabled={!isValid}
            width="100%"
          />
          <div className={styles['back-to-login']}>
            <Button
              size="inline-small"
              text="Back to login"
              appearance="text"
              onClick={() => {
                history.push('/');
              }}
            />
          </div>
        </form>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Reset password</title>
      </Helmet>
      <div className={styles.logo}>
        <Logo size="medium" url={homepage_logo} altText="logo" />
      </div>
      <div className={styles.wrapper}>
        {!newPassword && <Heading appearance="h4">Reset my password</Heading>}
        {renderScreen()}
      </div>
    </>
  );
};

export default ResetPasswordScreen;
